class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
        // Ensure animation is triggered
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });
    
        // this.addEventListener(
        //     'transitionend',
        //     () => {
        //         const containerToTrapFocusOn = this.classList.contains('is-empty')
        //             ? this.querySelector('.drawer__inner-empty')
        //             : document.getElementById('CartDrawer');
        //         const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        //         trapFocus(containerToTrapFocusOn, focusElement);
        //     },
        //     { once: true }
        // );
    
        document.body.classList.add('overflow-hidden');
    
        // Swipe detection for closing the drawer
        // const drawer = this;
        // let startX = 0;
    
        // const touchStartHandler = (event) => {
        //     startX = event.touches[0].clientX;
        // };
    
        // const touchEndHandler = (event) => {
        //     const endX = event.changedTouches[0].clientX;
        //     if (endX - startX > 50) {
        //         drawer.classList.remove('active');
        //     }
        // };
    
        // if (!this.swipeListenersAdded) {
        //     this.addEventListener('touchstart', touchStartHandler);
        //     this.addEventListener('touchend', touchEndHandler);
        //     this.swipeListenersAdded = true;
        // }
          document.documentElement.style.overflowY = 'hidden';
    }
    
    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
      document.documentElement.style.overflowY = '';
    }
  
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.addEventListener('change', this.check.bind(this));
    this.check();
  }

  check() {
      let total = 0;
      fetch('/cart.js').then(response => response.json()).then(data => {
        total = data.total_price / 100;

        let remainingAmount = document.querySelector('#remainingAmount');
        let giftText = document.querySelector('#giftText');
        let giftFullText = document.querySelector('#giftFullText');
        let Congratulations = document.querySelector('free-shipping-bar h4');
        let progressBar = document.querySelector('.sippingbar span');

        let freeShippingEl = document.querySelector('[data-free-shipping]');
        let freeGiftEl = document.querySelector('[data-free-gift]');
        let minimumEl = document.querySelector('[data-minimum]');

        let dataFreeShipping = freeShippingEl ? Number(freeShippingEl.getAttribute('data-free-shipping')) : null;
        let dataFreeGift = freeGiftEl ? Number(freeGiftEl.getAttribute('data-free-gift')) : null;
        let dataMinimum = minimumEl ? Number(minimumEl.getAttribute('data-minimum')) : null;

        if (dataMinimum !== null && total <= dataMinimum) {
          let percentage = Math.min(1, (total / dataMinimum)) * 25;
          if (progressBar) progressBar.style.width = `${percentage}%`;
          if (remainingAmount) remainingAmount.textContent = (dataMinimum - total).toFixed(2);
          if (giftText) giftText.textContent = 'Minimum Value';
        }

        if (dataMinimum !== null && dataFreeShipping !== null && total > dataMinimum && total <= dataFreeShipping) {
          let percentage = Math.min(1, (total / dataFreeShipping)) * 50;
          if (progressBar) progressBar.style.width = `${percentage}%`;
          if (remainingAmount) remainingAmount.textContent = (dataFreeShipping - total).toFixed(2);
          if (giftText) giftText.textContent = 'Free Shipping';
          document.querySelector('.col_one')?.classList.add('active');
        }

        if (dataFreeShipping !== null && dataFreeGift !== null && total > dataFreeShipping && total <= dataFreeGift) {
          let percentage = Math.min(1, (total / dataFreeGift)) * 100;
          if (progressBar) progressBar.style.width = `${percentage}%`;
          if (remainingAmount) remainingAmount.textContent = (dataFreeGift - total).toFixed(2);
          if (giftText) giftText.textContent = 'Free Gift';
          document.querySelector('.col_one')?.classList.add('active');
          document.querySelector('.col_two')?.classList.add('active');
        }

        if (dataFreeGift !== null && total > dataFreeGift) {
          if (progressBar) progressBar.style.width = `100%`;
          if (remainingAmount) remainingAmount.textContent = '';
          if (Congratulations) Congratulations.textContent = 'Congratulations!';
          if (giftFullText) giftFullText.textContent = 'Your Free Gift Will Be Applied At Checkout';
          document.querySelector('.col_one')?.classList.add('active');
          document.querySelector('.col_two')?.classList.add('active');
          document.querySelector('.col_three')?.classList.add('active');
        }
      });


  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: 'cart-drawer-items',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__footer',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__subscription',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: 'free-shipping-bar',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
